export default "__VITE_ASSET__B61e$ms2__"